import { type DrawNumber, getDrawNumber } from '../../../schema/draw/entry.js';
import type { Definition } from '../../../schema/frameworks/entry.js';
import { isCouponProduct } from '../../../schema/product/entry.js';
import { DEFAULT_DRAW_ID } from '../constants/index.js';

/**
 * Parses a draw ID string into product and draw number components.
 *
 * @param drawId - The draw ID string to parse, formatted as "drawNumber-product" or just "drawNumber"
 * @param definition - The game definition containing the list of draw products
 * @returns An object containing the parsed product and drawNumber, or null if parsing fails
 */
export function parseDrawId(
  drawId: string,
  definition: Definition
): { product: Definition['drawProducts'][number]; drawNumber: DrawNumber | typeof DEFAULT_DRAW_ID } {
  const drawIdParts = drawId.split('-');

  let product;
  if (drawIdParts.length > 1) {
    product = drawIdParts.at(-1);
  }
  if (!isCouponProduct(product)) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- We know that definition.drawProducts has at least one product, so this is safe
    product = definition.drawProducts[0]!;
  }

  const unparsedDrawNumber =
    drawIdParts.length > 1 ? drawIdParts.at(-2) : drawIdParts.length === 1 ? drawIdParts.at(0) : DEFAULT_DRAW_ID;

  if (unparsedDrawNumber === DEFAULT_DRAW_ID) {
    return {
      product,
      drawNumber: DEFAULT_DRAW_ID,
    };
  }

  return {
    product,
    drawNumber: getDrawNumber(unparsedDrawNumber),
  };
}
